// Update starting fee in ul li element
if (typeof gform !== 'undefined') {
  gform.addAction( 'gpcp_after_update_pricing', function( productId, GWConditionalPricing ) {

    // Jäsenyyden aktivointilomake
    if(GWConditionalPricing._formId === 20){

      // Vuosihinnan päivitys html-lohkoon
      var yearlyPrice =  document.querySelector('#ginput_base_price_20_32');
      var yearlyDefaultPrice = GWConditionalPricing._basePrices[32];
      yearlyPrice = yearlyPrice.value.replace(/€| /g, '');
      yearlyPrice = yearlyPrice.split(',')[0];


      var labelYearlyPresalePrice = document.getElementsByClassName('js-yearly-presale');

      for (let i = 0; i < labelYearlyPresalePrice.length; i++) {
        labelYearlyPresalePrice[i].innerHTML = yearlyPrice;
      }

      // Kuukausihinnan päivitys html-lohkoon
      var monhlyDefaultPrice = GWConditionalPricing._basePrices[51];


      var monthlyPrice =  document.querySelector('#ginput_base_price_20_51');

      monthlyPrice = monthlyPrice.value.replace(/€| /g, '');




      var labelPresalePrice = document.getElementsByClassName('js-presale');

      for (let i = 0; i < labelPresalePrice.length; i++) {
        if(monthlyPrice === monhlyDefaultPrice ) {

          labelPresalePrice[i].innerHTML = monthlyPrice;
        }
        else {
          labelPresalePrice[i].innerHTML = monthlyPrice + ' € ensimmäinen kuukausi ja sen jälkeen ' + monhlyDefaultPrice; // Oletusteksti
          // Alla olevaa käytettiin 10€ kampanjassa jossa kaikki liikut oli 15€ ja normaali jäsenyys 10€
          // labelPresalePrice[i].innerHTML = monthlyPrice + ' € ensimmäinen kuukausi ja sen jälkeen 34,90'; // Kampanjan teksti
        }

      }

      // Näillä koodeilla tehtiin tammikuun 2025 KOODILLA (Promocode) 15/20€ hintakampanja jäsenyydelle/kaikki liikut jäsenyydelle. Yläpuolelta rivi 40 kommentoidaan pois ja 42 otetaan käyttöön kampanjaa varten.

      // var labelAllAccessPrice = document.getElementsByClassName('js-all-access');


      // var promoCode = document.getElementById("input_20_16").value


      // var e = document.getElementById("input_20_12");
      // var value = e.value;

      // // Tarkistetaan että valittu sali ei ole avajaisetusali
      // if (!value.includes('#starte')) {
      //   //TArkistetaan että koodi on syötetty
      //   if(promoCode == 'PALUU15' || promoCode == 'LIIKKU15' || promoCode == 'PLUS15') {

      //     // Tekstin päivitys lomakkeen päällä olevaan listaelementtiin
      //     for (let i = 0; i < labelPresalePrice.length; i++) {
      //       labelAllAccessPrice[i].innerHTML =  '20,00 € ensimmäinen kuukausi ja sen jälkeen 39,90';

      //     }
      //   }
      // }
      // else {
      //   for (let i = 0; i < labelPresalePrice.length; i++) {
      //     labelAllAccessPrice[i].innerHTML =  '39,90 €';

      //   }
      // }
      // Tähän saakka kommentoidaan kampanjan jälkeen pois koodit käytöstä tammikuussa 2025

    }
  });
}
